import LanguageSelect from "./language-select";

export default LanguageSelect;
